(function () {
  function initYoutubeSection(root) {
    if (!root || root.dataset.youtubeSectionInitialized === 'true') {
      return;
    }

    var track = root.querySelector('[data-youtube-track]');
    var btnPrev = root.querySelector('[data-youtube-prev]');
    var btnNext = root.querySelector('[data-youtube-next]');
    var thumbs = root.querySelectorAll('[data-youtube-thumb]');
    var modal = root.querySelector('[data-youtube-modal]');
    var iframe = root.querySelector('[data-youtube-player]');
    var closeBtn = root.querySelector('[data-youtube-close]');

    if (!track || !btnPrev || !btnNext || !modal || !iframe || !closeBtn) {
      return;
    }

    function openModal(id) {
      var src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.setAttribute('src', src);
      modal.classList.remove('is-hidden');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      iframe.setAttribute('src', '');
      modal.classList.add('is-hidden');
      document.documentElement.style.overflow = '';
    }

    function scrollByAmount(direction) {
      var card = root.querySelector('[data-youtube-thumb]');
      var step = card ? card.getBoundingClientRect().width + 16 : 320;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    thumbs.forEach(function (thumb) {
      function trigger() {
        var id = thumb.getAttribute('data-video-id');
        if (id) {
          openModal(id);
        }
      }

      thumb.addEventListener('click', trigger);
      thumb.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger();
        }
      });
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    btnPrev.addEventListener('click', function () {
      scrollByAmount(-1);
    });

    btnNext.addEventListener('click', function () {
      scrollByAmount(1);
    });

    root.youtubeSectionCloseModal = closeModal;
    root.dataset.youtubeSectionInitialized = 'true';
  }

  function initAllYoutubeSections(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-youtube-section]').forEach(initYoutubeSection);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    document.querySelectorAll('[data-youtube-section]').forEach(function (root) {
      var modal = root.querySelector('[data-youtube-modal]');
      if (modal && !modal.classList.contains('is-hidden') && root.youtubeSectionCloseModal) {
        root.youtubeSectionCloseModal();
      }
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllYoutubeSections(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllYoutubeSections(document);
    });
  } else {
    initAllYoutubeSections(document);
  }
})();
